import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FormGroup,
  InputGroup,
  Button,
  Intent,
  IconName,
} from '@blueprintjs/core';
import { useAppDispatch } from '../../../hooks';
import { doRegistration } from '../reducer';
import Toaster from '../../../components/Toaster';
import { LOGIN } from '../routes';

function RegisterScreen() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pin, setPin] = useState('');

  const showToasterMessage = useCallback(
    async (message: React.ReactChild, intent: Intent, icon: IconName) => {
      (await Toaster).show({
        message,
        intent,
        icon,
      });
    },
    [],
  );

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const createUser = useCallback(() => {
    showToasterMessage(
      <>
        Usuário criado: <strong>{username}</strong>
      </>,
      Intent.SUCCESS,
      'tick-circle',
    );
  }, [showToasterMessage, username]);

  const dontCreateUser = useCallback(() => {
    showToasterMessage(
      <>
        Erro ao criar o usuário: <strong>{username}</strong>
      </>,
      Intent.DANGER,
      'warning-sign',
    );
  }, [showToasterMessage, username]);

  const handleRegister = useCallback(async () => {
    const response = await dispatch(
      doRegistration({ username, email, password, pin }),
    );

    if (response.meta.requestStatus === 'rejected') {
      dontCreateUser();
    } else {
      createUser();
      navigate(LOGIN());
    }
  }, [
    dispatch,
    navigate,
    dontCreateUser,
    createUser,
    username,
    email,
    password,
    pin,
  ]);

  return (
    <div
      className="register-container"
      style={{ maxWidth: '300px', margin: '0 auto', padding: '20px' }}
    >
      <FormGroup
        label="Username"
        labelFor="username-input"
        labelInfo="(required)"
      >
        <InputGroup
          id="username-input"
          placeholder="Enter your username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </FormGroup>

      <FormGroup label="Email" labelFor="email-input" labelInfo="(required)">
        <InputGroup
          id="email-input"
          placeholder="Enter your email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormGroup>

      <FormGroup
        label="Password"
        labelFor="password-input"
        labelInfo="(required)"
      >
        <InputGroup
          id="password-input"
          placeholder="Enter your password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </FormGroup>

      <FormGroup label="Pin" labelFor="pin-input" labelInfo="(opcional)">
        <InputGroup
          id="pin-input"
          placeholder="Enter your pin"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
        />
      </FormGroup>

      <Button intent="primary" text="Register" onClick={handleRegister} />
    </div>
  );
}

export default RegisterScreen;
